$(document).ready(function() {
  var metafield = $('.t4s-tab-wrapper').data('id-symbol-fmp') || "";
  var param;  
  if (metafield.trim() !== "") {param = metafield;} 
  else {param = document.URL.split("products/")[1].split("?")[0].toUpperCase();}  
    $.getJSON('https://financialmodelingprep.com/api/v3/ratios/'+param+'?limit=1&apikey=3ccf620ce9315de8a4996e601373f716', function(data){
      $.each(data, function(i, elem){

/*Overview*/
        
         if (elem.priceEarningsRatio == null) {var PE_ratio = 'n/a';} else
         {var PE_ratio = nFormatter(elem.priceEarningsRatio, 2);}
         $('#pe_ratio').append(PE_ratio);

         if (elem.dividendYield == null) {var Dividends_yield = 'n/a';} else
         {var Dividends_yield = elem.dividendYield.toLocaleString('en-US', {style: 'percent', minimumFractionDigits:2});}
         $('#div_yield').append(Dividends_yield);

/*Financial Efficiency*/

         if (elem.assetTurnover == null) {var assetTurnover_var = 'n/a';} else
         {var assetTurnover_var = nFormatter(elem.assetTurnover, 2);}
         $('#stat_asset_turnover').append(assetTurnover_var);

        
      });
    })
});
